import Cookies from 'js-cookie';
import ProgrammaticDialog from 'js/utils/ProgrammaticDialog';
import { setFormAssemblyState } from 'js/utils/FormAssemblySubmit';
import cookieName from '../restrictedContentCookieName';

/**
 * ModalAccess component.
 */
export default class ModalAccess {
  /**
   * Start the component
   */
  constructor({ element, children, options }) {
    this.element = element;
    this.children = children;
    this.options = options;

    // Bind class methods.
    this.setup = this.setup.bind(this);
    this.init = this.init.bind(this);
    this.handleDialogStateChange = this.handleDialogStateChange.bind(this);
    this.handleFormState = this.handleFormState.bind(this);
    this.handlePaywallState = this.handlePaywallState.bind(this);

    /**
     * The Dialog wrapper.
     *
     * @type {HTMLElement}
     */
    this.target = document.getElementById('modal-access');

    if (null != this.target) {
      this.setup();
    }
  }

  /**
   * Handle Dialog state changes.
   *
   * @param {Object} state The current Dialog state.
   */
  handleDialogStateChange({ expanded }) {
    if (expanded) {
      // Allow the modal to be closed by the user.
      document.body.addEventListener('click', this.dialog.hideOnOutsideClick);
      document.body.addEventListener('keydown', this.dialog.handleKeydownEsc);
    } else {
      document.body.removeEventListener(
        'click',
        this.dialog.hideOnOutsideClick,
      );
      document.body.removeEventListener(
        'keydown',
        this.dialog.handleKeydownEsc,
      );
    }
  }

  /**
   * Handle form submission state.
   *
   * @param {Event} event The event object.
   */
  handleFormState(event) {
    const { detail = {} } = event;
    const { status = '' } = detail;

    setFormAssemblyState(this.target, detail);

    if ('success' === status) {
      Cookies.set(cookieName, true, { expires: 30 });

      // Hide, then destroy, the Dialog. We don't need it anymore.
      this.dialog.hide();
      this.dialog.destroy();

      if (this.element.hasAttribute('download')) {
        this.element.click();
      } else {
        const { href } = this.element;
        window.location.href = href;
      }
    }
  }

  /**
   * Handle modal-signup state changes to remove the modal-access when a user
   * successfully submits their email address.
   *
   * @param {Event} event The event object.
   */
  handlePaywallState(event) {
    const { detail = {} } = event;
    const { status = '' } = detail;

    if ('success' === status) {
      // Hide, then destroy, the Dialog. We don't need it anymore.
      this.dialog.hide();
      this.dialog.destroy();
    }
  }

  /**
   * Determine if the modal should display.
   */
  setup() {
    const modalSignup = (
      document.querySelector('[data-component="modal-signup"]')
    );

    /*
     * Listen for modal-signup events so we're not presenting this modal after
     * a same-page signup.
     */
    if (null !== modalSignup) {
      modalSignup.addEventListener('sn.formstatechange', this.handlePaywallState); // eslint-disable-line max-len
    }

    if ('true' !== Cookies.get(cookieName)) {
      this.init();
    }
  }

  /**
   * Initialize the modal.
   */
  init() {
    // Instantiate the Dialog.
    this.dialog = new ProgrammaticDialog(
      this.target,
      { onStateChange: this.handleDialogStateChange },
    );

    // Set the component element as the Dialog controller.
    this.dialog.setDialogController(this.element);

    // Set up the close button.
    const close = this.target.querySelector('.modal-access__close');
    if (null !== close) {
      close.addEventListener('click', this.dialog.hide);
    }

    this.target.addEventListener('sn.formstatechange', this.handleFormState);
  }
}
